export interface POComment {
  id: string;
  authorName: string;
  authorInitials: string;
  date: string;
  text: string;
}

export interface PODocument {
  name: string;
  size: string;
  key: string;
}

export interface PODetailView {
  id: string;
  name: string;
  status: string;
  statusLabel: string;
  warningMessage?: string;
  sourceType: string;
  makerToExecute: string;
  companyToBill: string;
  poType: string;
  rappiOwner: string;
  document?: PODocument;
  poBudget: number;
  poCurrency: string;
  coInvestmentPct?: number;
  reInvestmentPct?: number;
  effectiveDate: string;
  pointOfContact: string;
  contactEmail: string;
  agency?: string;
  detailBrief?: string;
  tags?: string[];
  approvalStatus: string;
  comments: POComment[];
}

export const PURCHASE_ORDER_MOCK: PODetailView = {
  id: 'po-2026-001',
  name: 'Coca Cola Julio-Agosto 2026',
  status: 'waiting_for_kam',
  statusLabel: 'Waiting for KAM',
  warningMessage:
    'Returned by Finance- Review the comments in the Comments and make the corrections before submitting',
  sourceType: 'Client',
  makerToExecute: 'The Coca Cola Company',
  companyToBill: 'Grupo Coca Cola Femsa SA de CV',
  poType: 'JBP/ Always on',
  rappiOwner: 'nombre.apellido@rappi.com',
  document: {
    name: 'Ferses_OrdendeCompra_2026.pdf',
    size: '2.3 MB',
    key: 'ferses_orden'
  },
  poBudget: 1000000,
  poCurrency: 'COP',
  coInvestmentPct: 10,
  reInvestmentPct: 20,
  effectiveDate: '2026-06-01',
  pointOfContact: 'Fabrizio Santini',
  contactEmail: 'fabrizio.santini@femea.com',
  agency: 'Publicis SA. de CV.',
  approvalStatus: 'pending',
  comments: [
    {
      id: '1',
      authorName: 'Nicola Barragán',
      authorInitials: 'NB',
      date: 'JUL 07, 2026',
      text: 'Missing PO Number confirmation and budget documentation. Please verify the authorized signature on the uploaded document before resubmitting.'
    }
  ]
};
